<template>
  <div class="wrapper">
    <div class="bg-page" :style="bgPage"></div>
    <div class="panel">
      <div class="body-panel-login">
        <b-form>
          <img
            class="img-fluid mx-auto d-block"
            src="@/assets/logo-mrv.png"
            alt=""
          />
          <b-form-group>
            <b-button
              type="button"
              @click="startSSO()"
              class="btn-block"
              variant="outline-primary"
              :disabled="loading"
              ><span v-if="!loading"
                ><font-awesome-icon :icon="['fas', 'key']" /> Iniciar sessão
              </span>
              <b-spinner
                v-if="loading"
                small
                variant=""
                type="grow"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </b-form-group>
        </b-form>
        <div>
          <img
            class="img-fluid mx-auto d-block float-left"
            src="@/assets/logo-indecx.png"
            alt=""
            width="70"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mrv-sso',
};
</script>

<script>
import backgroundImage1 from '../../../../assets/1.png';
import backgroundImage2 from '../../../../assets/2.png';
import backgroundImage3 from '../../../../assets/3.png';
import backgroundImage4 from '../../../../assets/4.png';
import backgroundImage5 from '../../../../assets/5.png';
import backgroundImage6 from '../../../../assets/6.png';
import backgroundImage7 from '../../../../assets/7.png';
import axios from 'axios';

export default {
  data: () => ({
    loading: false,
    bgPage: {
      background: null,
      backgroundRepeat: null,
      backgroundSize: null,
      backgroundPosition: null,
    },
  }),
  methods: {
    async startSSO() {
      this.loading = true;
      try {
        const resp = await axios.post(
          `${process.env.API_ROOT}/sso/url`,
          { type: 'mrv' },
          {
            headers: { 'Access-Control-Allow-Origin': '*' },
          },
        );
        if (resp.status === 200) {
          window.location.href = resp.data.url;
        } else {
          this.makeToast('Erro', resp.data);
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.makeToast('Erro', error.response.data.message);
      }
    },
    makeToast(message, title, append = false) {
      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: 'danger',
      });
    },
  },
  created() {
    const imgs = [
      backgroundImage1,
      backgroundImage2,
      backgroundImage3,
      backgroundImage4,
      backgroundImage5,
      backgroundImage6,
      backgroundImage7,
    ];

    this.bgPage.background = `url('${
      imgs[Math.floor(Math.random() * imgs.length)]
    }')`;
    this.bgPage.minHeight = '100vh';
    this.bgPage.minWidth = '100vw';
    this.bgPage.backgroundRepeat = 'no-repeat';
    this.bgPage.backgroundSize = 'cover';
    this.bgPage.backgroundAttachment = 'fixed';
    this.bgPage.backgroundPosition = 'center';
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.wrapper {
  @extend %center;
  .bg-page {
    position: fixed;
    top: 0;
    left: 0;
    transform: scale(1);
    opacity: 0.6;
    z-index: -1;
    transition: all 0.2s linear;
    animation: zoomOut 0.4s;
  }

  @keyframes zoomOut {
    from {
      transform: scale(1.3);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 0.6;
    }
  }

  .panel {
    width: 90%;
    max-width: 420px;

    border-radius: 5px;
    display: flex;
    flex-direction: column;
    @include bg-color(rgba(255, 255, 255, 0.8));
    @media screen and (min-width: 576px) {
      width: 100%;
    }

    .body-panel-login {
      // @include bg-color($white);
      @extend %double-padding-left,
        %double-padding-right,
        %double-padding-top,
        %double-padding-bottom;

      form {
        @extend %double-padding-top, %double-padding-bottom;
        .img-fluid {
          width: 50%;
          margin-bottom: 30px;
        }
        .input-group-text {
          border: none;
          @include bg-color($white);
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-right: none;
        }
        .form-control {
          box-shadow: none;
          border: none;
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
          @include bg-color($white);
          text-indent: 0;
          padding: 0;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-left: none;
        }
      }
      button {
        border-radius: 30px;
      }
    }
  }
}

.flag-align {
  position: absolute;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/sso/mrv.vue